import { MonitoringLevel } from "@services/devices/types";
import {
  ConferenceParticipant,
  ConferenceStatus,
  ConnectionState,
  MeetingInstance,
  MeetingPurpose,
  MeetingSetup,
  MeetingType,
} from "@services/meetings/types";

export const isRecurrentMeeting = (meeting?: MeetingInstance) => {
  return (
    meeting &&
    meeting.type !== MeetingType.AdHoc &&
    meeting.scheduledMeeting &&
    meeting.scheduledMeeting.recurrence &&
    meeting.scheduledMeeting.recurrence != ""
  );
};

export const isMeetingFinished = (meeting?: MeetingInstance) => {
  if (
    meeting &&
    meeting.status &&
    meeting.status !== ConferenceStatus.Cancelled &&
    meeting.status !== ConferenceStatus.Completed
  ) {
    if (meeting.status.startsWith("InProgress")) {
      return false;
    } else if (!isRecurrentMeeting(meeting)) {
      let now = new Date();
      let endTime = new Date(meeting.end ?? 0);
      return endTime < now;
    }
  }
  return true;
};

export const isMeetingInSchedule = (meeting?: MeetingInstance) =>
  meeting?.status === ConferenceStatus.Scheduled;

export const isMeetingIsCancelled = (meeting?: MeetingInstance) =>
  meeting?.status === ConferenceStatus.Cancelled;

export const isMeetingInProgress = (meeting?: MeetingInstance) => {
  if (
    meeting &&
    meeting.status &&
    meeting.status != "Cancelled" &&
    meeting.status != "Completed"
  ) {
    var now = new Date();
    if (meeting.status && meeting.status.startsWith("InProgress")) {
      return true;
    } else if (meeting.end) {
      var endTime = new Date(meeting.end);
      if (endTime.getTime() < now.getTime()) return false;
    } else return true;
    var startTime = new Date(meeting.start ?? 0);
    if (now.getTime() > startTime.getTime()) return true;
    return false;
  }
  return false;
};

export const isMeetingInTheFuture = (meeting?: MeetingInstance) => {
  let now = new Date();
  let startTime = new Date(
    meeting?.setupTime ? meeting?.setupTime : meeting?.start ?? 0
  );
  return startTime > now;
};
export const isParticipantConnected = (participant: ConferenceParticipant) => {
  return (
    participant.status === ConnectionState.Connected ||
    participant.status === ConnectionState.PartiallyConnected
  );
};

export const canParticipantInterract = (
  participant: ConferenceParticipant,
  meeting?: MeetingInstance
) => {
  return (
    !isMeetingFinished(meeting) &&
    participant.externalId &&
    isParticipantConnected(participant)
  );
};

export const inThePast = (dateEnd?: number) => {
  var now = new Date();
  if (dateEnd) {
    var end = new Date(dateEnd);
    return now > end;
  }
  return false;
};

export const isParticipantManaged = (participant: ConferenceParticipant) => {
  return (
    (participant.device?.monitoringLevel !== MonitoringLevel.None &&
      participant.room?.managed) ??
    false
  );
};

export const isLightEVCSMeeting = (meeting?: MeetingInstance) => {
  // we want to disable stuff only in specific cases, previously only VMR meeting that were not Pexip and not CMS meeting were light meeting
  if (meeting?.type === MeetingType.VMR) {
    return !meeting.evcsFullMode;
  }
  return false;
};

export const isManualConference = (meeting?: MeetingInstance) => {
  return (
    meeting?.scheduledMeeting &&
    meeting?.scheduledMeeting.meetingSetup === MeetingSetup.Manual
  );
};

export const isRoomSweepMeeting = (meeting?: MeetingInstance) => {
  return meeting?.scheduledMeeting?.meetingPurpose === MeetingPurpose.Sweep;
};
